module.exports = __webpack_public_path__ + "static/media/COVID_INFO.49d9f862.jpg";